const responsiveStyles = {
  height: { lg: "144px", md: "126px", xs: "78px" },
  width: { lg: "144px", md: "126px", xs: "78px" }
};
const skeletonResponsiveStyles = {
  borderRadius: "100px",
  width: { lg: "144px", md: "126px", xs: "78px" }
};
export {
  responsiveStyles,
  skeletonResponsiveStyles
};
